import { Globe, Workflow } from "lucide-react";

export const TOKEN_KEY = "tme_admin_token";
export const DIVISION_KEY = "tme_admin_division";

/* Per-division endpoint + display config. Keeping this in one map keeps the
 * load/render logic identical for both divisions. */
export const DIVISIONS = {
  websites: {
    label: "Websites",
    Icon: Globe,
    endpoint: "/admin/website-intake-submissions",
    eyebrow: "Admin · Website Intakes",
    headline: "Website Build Brief submissions",
    subhead: "Green rows have cleared Stripe. Everything else is awaiting payment or follow-up.",
    detailRoute: (id) => `/admin/intakes/${id}`,
    supportsKickoff: true,
    packageLabels: {
      starter: "Starter Website — $1,500",
      growth: "Growth Website — $2,500",
      premium: "Premium Website — $3,500",
      not_sure: "Not Sure Yet",
    },
  },
  revenue: {
    label: "Revenue Systems",
    Icon: Workflow,
    endpoint: "/admin/revenue-intake-submissions",
    eyebrow: "Admin · Revenue Intakes",
    headline: "Revenue Systems brief submissions",
    subhead: "Pre-checkout briefs across the four Revenue System products. Olive rows have cleared Stripe.",
    detailRoute: null, // no per-row detail page yet
    supportsKickoff: false,
    packageLabels: {
      audit: "Revenue Audit — $497",
      lead_capture: "Lead Capture System — $2,000",
      follow_up: "Follow-Up + Booking System — $4,250",
      revenue_conversion: "Revenue Conversion System — $10,000",
    },
  },
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return `${d.toLocaleDateString()} · ${d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
  } catch {
    return iso;
  }
};

export const fmtMoney = (cents, currency) => {
  if (!cents) return "—";
  const v = cents / 100;
  const cur = (currency || "USD").toUpperCase();
  return `${cur} ${v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
